import React, { Component } from 'react';
import { Link } from "react-router-dom";
export class Chapter10 extends Component {
  static displayName = Chapter10.name;

  render () {
    return (
      <div>
        <section id="jeevan-parichay" className="container" style={{ marginTop: "60px", marginBottom: "80px" }}>
        <div className="card" style={{ padding: "34px 36px" }}>
          {/* Main Heading */}
          <h2 style={{color: "var(--accent)",textAlign: "center",fontSize: "clamp(26px,3vw,38px)",marginBottom: "18px",}}>
            🌼 अध्याय—10: पर्वत, गुफाएँ और ऋषि-लोक से प्राप्त दिव्य ज्ञान 🌼
          </h2>

          {/* Intro */}
          <div style={{display: "flex",gap: "24px",alignItems: "center",flexWrap: "wrap",marginBottom: "18px",}}>
            {/* Image */}
            <div style={{ flex: "0 0 220px", textAlign: "center" }}>
              <div style={{width: "200px", height: "200px", borderRadius: "50%", overflow: "hidden", margin: "0 auto",border: "4px solid var(--accent)",boxShadow: "0 20px 60px rgba(0,0,0,0.6)"}}>
                <img src="/images/IMG_5427-removebg-preview.png" alt="Swami Brahmanand Saraswati Ji" style={{ width: "100%", height: "100%", objectFit: "cover" }}/>
              </div>
              <div style={{ marginTop: "10px", color: "var(--muted)", fontSize: "13px" }}>
                पूज्य स्वामी ब्रह्मानंद सरस्वती जी
              </div>
            </div>

            {/* Intro Text */}
            <div style={{ flex: 1, minWidth: "260px" }}>
              <p style={{ margin: 0, color: "rgba(255,235,200,0.95)", lineHeight: 1.8 }}>
                स्वामी ब्रह्मानंद सरस्वती जी महाराज का जीवन केवल गाँव, समाज और शिष्यों तक सीमित नहीं था। उनके भीतर बचपन से ही एक अद्भुत खिंचाव था— पर्वतों, नदियों, गुफाओं और वन प्रदेशों की ओर। जैसे कोई अदृश्य शक्ति बार-बार उन्हें बुलाती हो— कि “आओ, यहाँ वह ज्ञान छिपा है जिसे साधारण आँखें नहीं देख सकतीं।” यह अध्याय उसी दिव्य यात्रा का वर्णन है जहाँ उन्होंने ऋषियों से संवाद किया, गुफाओं में ध्यान लगाया, और “निर्विकल्प ज्ञान” की उच्चतम अवस्था को पाया।
              </p>
            </div>
          </div>

          <hr style={{border: "none", height: "1px", background: "rgba(255,255,255,0.03)", margin: "18px 0 22px",}}/>

          {/* Narrative */}
          <div style={{ marginTop: "22px" }}>
            {/* <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>श्मशान में की गई उनकी कठोर तपस्या।</h3> */}
            
            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>1. पर्वतों का आकर्षण — किशोर अवस्था से ही</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              बहुत कम आयु में ही गुरुदेव जी के भीतर एक अनोखा पुकार उठी— “शांत गाँव से बाहर, कुछ और गहरा, कुछ और विशाल— जहाँ आत्मा स्वयं को पहचान सके।” जैसे ही अवसर मिलता, वे अकेले निकल पड़ते— घने जंगलों में, सूने रास्तों पर, नदियों के किनारे बैठकर घंटों तक ध्यान में लीन हो जाते। उनकी माता अक्सर कहतीं— “यह बालक संसार से नहीं, किसी और लोक से बुलाया गया है।”
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>2. गुफाओं की तपस्थली — जहाँ मौन बोलता था</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              किशोर अवस्था से ही उन्होंने बिहार, झारखंड, उत्तरप्रदेश और मध्यप्रदेश के घने पहाड़ी क्षेत्रों में कई गुफाओं को अपनी साधना का निवास बनाया। उन गुफाओं की रातें— न कोई दीपक, न कोई कंबल, न कोई भय। सिर्फ पर्वतीय हवा की ठंडी फुहार और ध्यान की अग्नि का आंतरिक ताप। उन गुफाओं में आज भी कई साधक बताते हैं— “यहाँ कभी एक दिव्य तपस्वी महीनों तक समाधि में लीन रहा था।”
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>3. ऋषियों से मिलन — लोक से परे एक संसार</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              उनकी साधना के दौरान कई बार ऐसे अनुभव हुए जो सामान्य मनुष्य के लिए असंभव माने जाते हैं। एक बार वे अमरकंटक की ओर जा रहे थे। रास्ते में एक अत्यंत वृद्ध संन्यासी मिले— जिनकी आँखों में ऐसा प्रकाश था जो मानव से अधिक देवत्व का अनुभव कराता था। उस संत ने कहा— “तुम्हारा मार्ग साधारण नहीं है। तुम्हें आगे वह ज्ञान मिलना है जो केवल ऋषि-परंपरा के लिए सुरक्षित है।” स्वामी जी ने बाद में बताया कि वह संत वहाँ फिर कभी नहीं दिखे। वे मानते थे— “वह कोई साधारण संत नहीं थे— वे ऋषि-लोक के मार्गदर्शक थे।”
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>4. अप्रकट गुरु-शक्ति का आह्वान</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              इन दिव्य स्थलों पर स्वामी जी को कई बार ऐसा लगा मानो कोई अदृश्य शक्ति उनके ध्यान को संभाल रही है। साधना के उग्र समय में जब सांस रुकती-सी लगती, तब जैसे कोई उनकी पीठ पर अदृश्य कर से स्पर्श करता— और साधना सहज हो जाती। वे कहते थे— “जहाँ साधक अपने पूरे समर्पण से बढ़ता है, वहाँ गुरु-शक्ति स्वयं मार्ग बना देती है।”
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>5. समाधि की अवस्था — जहाँ समय ठहर जाता है</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              गुफाओं और पर्वतों पर उन्होंने वर्षों तक निर्विकल्प समाधि का अभ्यास किया। इस अवस्था में— न कोई विचार, न कोई स्मृति, न अतीत, न भविष्य।
              
              सिर्फ शुद्ध अस्तित्व।
              ।। सुषुप्ति से भी परे एक गहरे प्रकाश का अनुभव। ।।
              
              यह अनुभूति उनके शिष्यों के जीवन में प्रत्यक्ष दिखती थी— उनके चेहरे के तेज, उनकी वाणी की गंभीरता, और उनकी उपस्थिति की स्थिरता में।
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>6. अघोर, तंत्र और वेदांत—सबका सम्मिलित ज्ञान</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              स्वामी जी केवल वेदांत के ज्ञानी नहीं थे— उनके भीतर अघोर सिद्ध पीठों का अनुभव भी था।
                <br/>
                ✔ उन्होंने भूखे रहकर तपस्या की<br/>
                ✔ श्मशान में साधना की<br/>
                ✔ देवी के स्वरूप का दर्शन किया<br/>
                ✔ ऋषियों से तांत्रिक रहस्य सुने<br/>
                ✔ और अंत में<br/>
                सब ज्ञानों को वेदांत की एकता में पिरो दिया। वे कहा करते थे— “ज्ञान एक है, मार्ग अनेक हैं। साधक के लिए जरूरी है— मन की पवित्रता और पूर्ण समर्पण।”
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>7. आधी रात की गुफा — वह दिव्य अनुभव</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              एक बार विंध्य पर्वत की एक गुफा में वे अकेले ध्यान में बैठे थे। आधी रात थी। चारों ओर गहरी निस्तब्धता। अचानक एक तेज प्रकाश गुफा में फैला और उन्हें लगा मानो कोई दिव्य शक्ति उनके सामने खड़ी हो। उस दिव्य आभा से एक ही वाक्य प्रकट हुआ— “तुम्हें आगे चलकर असंख्य आत्माओं का उद्धार करना है।” उनका शरीर कंप उठा। उन्होंने आँखें खोलीं— लेकिन प्रकाश लुप्त हो चुका था। उस दिन के बाद उनके भीतर की साधना जैसे दुगनी गति से बढ़ने लगी।
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>8. पर्वतों का वरदान — ज्ञान का स्रोत</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              इन यात्राओं से उन्होंने केवल ज्ञान नहीं पाया, बल्कि शांतता, धैर्य, और आंतरिक शक्ति का अमूल्य खजाना प्राप्त किया। जब वे गाँव लौटते, तो ग्रामीण कहते— “गुरुदेव पहले जैसे नहीं रहे। उनके अंदर अब वह तेज है जो ऋषियों में होता है।”
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>अध्याय का सार</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              स्वामी ब्रह्मानंद सरस्वती जी महाराज की पर्वतीय और गुफा-साधना केवल एक अध्यात्मिक यात्रा नहीं थी— वह वह दिव्य प्रसंग था जिसने उन्हें युग-पुरुष, मार्गदर्शक और परिव्राजक साधक बनाया। उनकी यह यात्रा दिखाती है कि— जब साधक सत्य की खोज में समर्पण कर देता है, तो स्वयं प्रकृति उसे ऋषि-ज्ञान तक ले जाती है।
            </p>
          </div>

          {/* CTA */}
          <div style={{ textAlign: "center", marginTop: "26px" }}>
            <Link to="/Chapter9" className="btn" style={{ display: "inline-block" }}>पिछला अध्याय</Link>-
            <Link to="/Chapter11" className="btn" style={{ display: "inline-block" }}>अगला अध्याय</Link>
          </div>
        </div>
      </section>
      </div>
    );
  }
}